var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgvAboutUsCardThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 128,
    viewBox: "0 0 105 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1646 7.34473C85.8805 7.34473 104.295 24.5883 104.295 45.8594C104.295 53.7134 101.785 61.0183 97.4742 67.1089C90.7653 75.5201 77.3476 94.7332 77.3476 104.295H48.982C48.982 94.7332 35.5643 75.5201 28.8554 67.1089C24.5448 61.0183 22.0342 53.7134 22.0342 45.8594C22.0342 24.5883 40.4487 7.34473 63.1646 7.34473Z",
    fill: "url(#paint0_linear_79_896)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1819 6.7207C86.1965 6.7207 104.854 24.1741 104.854 45.7039C104.854 53.6534 102.31 61.0472 97.9426 67.2118C91.1455 75.7254 77.5514 95.1721 77.5514 104.851",
    stroke: "#31303A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1814 6.7207C40.1668 6.7207 21.5098 24.1741 21.5098 45.7039C21.5098 53.6534 24.0533 61.0472 28.4207 67.2118C35.2178 75.7254 48.8119 95.1721 48.8119 104.851",
    stroke: "#31303A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7373 117.266V122.675C49.7373 124.884 51.5282 126.675 53.7373 126.675H72.6222C74.8314 126.675 76.6222 124.884 76.6222 122.675V117.266",
    stroke: "#302F3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5371,
    y: 104.295,
    width: 35.2548,
    height: 7.34475,
    rx: 2,
    stroke: "#302F3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.7021,
    y: 111.89,
    width: 34.9504,
    height: 5.37699,
    rx: 2,
    stroke: "#302F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1189 15.3363C26.609 8.98706 12.8891 8.08269 9.40967 14.1093C4.21282 23.1105 23.8282 44.1646 53.2218 61.135C82.6154 78.1055 110.657 84.5658 115.853 75.5646C118.53 70.9294 114.626 63.098 106.196 54.274",
    stroke: "url(#paint1_linear_79_896)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.188 14.613C99.7156 8.92561 112.511 8.31802 115.854 14.1081C121.051 23.1093 101.435 44.1635 72.0418 61.1339C42.6482 78.1043 14.6071 84.5646 9.41024 75.5634C6.73364 70.9274 10.6389 63.0942 19.0722 54.2683",
    stroke: "url(#paint2_linear_79_896)",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_896",
    x1: 22.0342,
    y1: 7.34473,
    x2: 126.552,
    y2: 60.6795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_896",
    x1: 70.5733,
    y1: 32.7614,
    x2: 53.2228,
    y2: 61.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_896",
    x1: 71.1582,
    y1: 59.6035,
    x2: 55.1147,
    y2: 32.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgvAboutUsCardThree);
export default __webpack_public_path__ + "static/media/BGVAboutUsCardThree.7c858b6269451a0dbb354855c8ff4972.svg";
export { ForwardRef as ReactComponent };